import React from 'react';
import './Abouthome.css';

const Abouthome = ({ content }) => (
  <section className="about-section" aria-labelledby="about-title">
    <div className="about-container">
      <div className="about-content">
        <h1 id="about-title" className="about-title">{content.title}</h1>
        {content.paragraphs.map((paragraph) => <p className="about-description" key={paragraph}>{paragraph}</p>)}
      </div>
      <div className="about-gallery" aria-label={content.galleryLabel}>
        {content.images.map((image) => (
          <figure key={image.src} className="gallery-item">
            <img src={image.src} alt={image.alt} loading="lazy" className="gallery-image" />
            <figcaption className="image-overlay" aria-hidden="true" />
          </figure>
        ))}
      </div>
    </div>
  </section>
);

export default Abouthome;

